/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/ach_imoge.png";
import team2 from "assets/images/kng_imoge.png";
import Grid2 from "@mui/material/Grid2";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 8 }} sx={{ mb: 6 }}>
            <MKTypography variant="h5" color="white" mt={3} mb={1} fontWeight="regular">
              우리의 팀원을 소개합니다.
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              "하고 싶었던 일들은 어떻게든 결과를 만들어 내는 편입니다. 이것이 우리의 팀원들이 가진 가치입니다."
            </MKTypography>
          </Grid2>
        </Grid2>
        <Grid2 container spacing={3}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="안 창현"
                position={{ color: "info", label: "CEO & FOUNDER (Product Manager)" }}
                description="프로젝트 매니저는 사용자 경험을 최우선으로 생각하며, 기획 단계부터 개발, 출시까지 전 과정을 주도적으로 이끌며, 요구사항을 조화롭게 융합하여 혁신적인 제품과 서비스를 만들어냅니다."
              />
            </MKBox>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="김 남균"
                position={{ color: "info", label: "CEO & FOUNDER (Backend Developer)" }}
                description="서버 개발자는 웹사이트나 애플리케이션의 핵심 기능을 담당하는 전문가입니다. 사용자의 요청을 처리하고 데이터를 관리하며, 안전하고 효율적인 시스템을 구축하는 역할을 수행합니다."
              />
            </MKBox>
          </Grid2>
        </Grid2>
      </Container>
    </MKBox>
  );
}

export default Team;
